import { useUIStore } from "../../store/uiStore";
import { hapticFeedback } from "../../telegram/init";

interface Slot {
  position: number;
  cityId: number | null;
  cityName: string | null;
  playerName: string | null;
  playerId: number | null;
}

interface User {
  id: number;
  displayName: string;
}

interface Props {
  slot: Slot;
  user: User | null;
  onClose: () => void;
}

export function SlotDetailPanel({ slot, user, onClose }: Props) {
  const setScreen = useUIStore((s) => s.setScreen);

  const isOwn     = slot.playerId !== null && slot.playerId === user?.id;
  const occupied  = slot.cityId !== null;

  function handleGoToCity() {
    hapticFeedback("medium");
    onClose();
    setScreen("city");
  }

  return (
    <>
      <div className="panel-overlay" onClick={onClose} />
      <div className="panel-sheet">
        <div className="panel-handle" />

        {isOwn ? (
          /* — Own city — */
          <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: "var(--space-md)" }}>
            <span style={{ fontSize: "2.5rem" }}>{"\u{1F451}"}</span>
            <h2 style={{ color: "var(--terra-dark)", textAlign: "center" }}>
              {slot.cityName}
            </h2>
            <div style={{
              fontSize: "0.85rem",
              color: "var(--ink-faded)",
              fontFamily: "var(--font-display)",
              textTransform: "uppercase",
              letterSpacing: "0.05em",
            }}>
              Your city — Slot {slot.position + 1}
            </div>
            <button
              className="btn-primary"
              onClick={handleGoToCity}
              style={{ width: "100%", padding: "14px", marginTop: "var(--space-sm)" }}
            >
              Go to City
            </button>
          </div>
        ) : occupied ? (
          /* — Other player's city — */
          <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: "var(--space-md)" }}>
            <span style={{ fontSize: "2.5rem" }}>{"\u{1F3E0}"}</span>
            <h2 style={{ color: "var(--ink)", textAlign: "center" }}>
              {slot.cityName}
            </h2>
            <div style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: "4px",
              padding: "var(--space-md) var(--space-xl)",
              background: "var(--parchment)",
              borderRadius: "var(--radius)",
              border: "1px solid var(--sand)",
              width: "100%",
            }}>
              <span style={{
                fontFamily: "var(--font-display)",
                fontSize: "0.65rem",
                textTransform: "uppercase",
                letterSpacing: "0.05em",
                color: "var(--ink-faded)",
              }}>
                Ruler
              </span>
              <span style={{
                fontSize: "1rem",
                fontWeight: 600,
                color: "var(--ink)",
              }}>
                {slot.playerName ?? "Unknown"}
              </span>
            </div>
            <div style={{
              fontSize: "0.8rem",
              color: "var(--ink-faded)",
              textAlign: "center",
              fontStyle: "italic",
              marginTop: "var(--space-sm)",
            }}>
              Diplomacy, trade & espionage coming soon.
            </div>
          </div>
        ) : (
          /* — Empty slot — */
          <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: "var(--space-md)" }}>
            <span style={{ fontSize: "2.5rem", opacity: 0.4 }}>{"\u{1F3DD}\uFE0F"}</span>
            <h2 style={{ color: "var(--ink-faded)", textAlign: "center" }}>
              Empty Slot
            </h2>
            <div style={{
              padding: "var(--space-md)",
              background: "var(--parchment)",
              borderRadius: "var(--radius)",
              border: "1px solid var(--sand)",
              fontSize: "0.85rem",
              color: "var(--ink-faded)",
              textAlign: "center",
              lineHeight: 1.6,
            }}>
              Slot {slot.position + 1} is unoccupied. Players can found a colony here.
            </div>
            <div style={{
              fontSize: "0.8rem",
              color: "var(--ink-faded)",
              textAlign: "center",
              fontStyle: "italic",
            }}>
              Colony founding coming in a future update.
            </div>
          </div>
        )}
      </div>
    </>
  );
}
